import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as dms from '../../../dms'

export const DOC = gql`
  ${dms.data.fragments.variableValue.DOC}
  fragment FragmentLinkDestination on LinkDestination {
    navigationId
    segmentId
    variables {
      ...FragmentVariableValue
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentLinkDestinationFragment,
  ents.core.display.Link.Destination
>({
  navigationId: transformers.PASS_THROUGH,
  segmentId: transformers.PASS_THROUGH,
  variables: dms.data.fragments.variableValue.LOOKUP_TRANSFORMER,
})
